const locale = "sv-SE"; //TODO: get from settings
const nbrFmt = new Intl.NumberFormat(locale);
const currFmt = new Intl.NumberFormat(locale, {
  style: "currency",
  currency: "SEK"
});

export const formatNumber = number => nbrFmt.format(number);
export const formatCurrency = number => currFmt.format(number);
